const JSConstants = require('_core_ext/constants');
const imagePlugin = require('_core_ext/pages/createreturn/imagePlugin');
const upload = require('_core_ext/pages/createreturn/upload');

const submitBtn = document.querySelector(JSConstants.ID_SUBMIT_BTN);
let selectedImages = [];


function initializeImgPlugin () {
    imagePlugin.init(selectedImages, JSConstants.ID_IMAGE_UPLOADER_INPUT, {
        accept: ['.png', '.jpg', '.jpeg']
    });
}

function initializeEvents() {
    submitBtn.addEventListener('click', (event) => {
        event.preventDefault();
        submitBtn.setAttribute('disabled', true);
        setTimeout(() => submitBtn.removeAttribute('disabled'), 2000);
        upload.init(selectedImages);
    });
}


var createreturn = {
    init: function () {
        initializeImgPlugin();
        initializeEvents();
    }
};

module.exports = createreturn;
